<template>
    <v-menu
      v-model="menu"
      min-width="250"
      transition="slide-x-transition"
      left
      bottom
      :close-on-click="false"
      :close-on-content-click="false"
      class="list-icon"
    >
      <v-btn slot="activator"  flat icon @click="open()">
        <v-icon>list</v-icon>
      </v-btn>
  
      <v-card>
        <v-card-title class="subtitle-1 py-2">
          Select columns
          <v-spacer></v-spacer>
          <v-btn color="error" flat icon class="ma-0" @click.native="close()">
            <v-icon color="error">close</v-icon>
          </v-btn>
        </v-card-title>
        <v-divider></v-divider>
        <v-card-text class="px-0 pt-0">
          <v-list dense>
            <v-list-tile v-for="column in columns" :key="column.key" dense>
              <v-checkbox
                color="primary"
                dense
                :label="column.text"
                v-model="column.enabled"
                :disabled="column.disabled"
                @change="updateColumns"
              />
            </v-list-tile>
          </v-list>
        </v-card-text>
      </v-card>
    </v-menu>
  </template>
  
  <script>
export default {
  name: "TableColumns",
  components: {},
  props: {},
  data() {
    return {
      menu: false, // Controls visibility of the column manager
    };
  },
  methods: {
    open() {
      this.menu = true;
    },
    close() {
      this.menu = false;
    },
    updateColumns() {
      this.$store.commit("updateColumns", this.columns);
    },
  },
  computed: {
    columns() {
      return this.$store.getters.getCheckViewColumns;
    },
  },
};
</script>
<style scoped>
.list-icon {
  position: absolute;
  top: -8px;
  z-index: 1;
  left: -6px;
  /* right: 24px; */
}
</style>
